import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../reducers';
import LinkPanel from '../../../../containers/Editor/EditPanel/LinkPanel';
import { Button } from '../styles';
import { updateEditableIframe } from '../../../../containers/Editor/actions';
import { getLinkUrlData, LinkUrlData } from '../../../../containers/Editor/utils/helpers';

interface IframePanelProps {
	page: number;
	id: string;
	src: string;
	defaultSrc: string;
	dispatch: Dispatch<StoreState>;
}

const IframePanel = ({
	page,
	id,
	src,
	defaultSrc,
	dispatch
}: IframePanelProps) => {
	const handleChange = (linkData: LinkUrlData) => {
		const newSrc = linkData.data.href;
		if (newSrc !== src) {
			dispatch(updateEditableIframe(page, id, {
				src: newSrc,
			}));
		}
	};

	const handleResetClick = () => {
		dispatch(updateEditableIframe(page, id, {
			src: defaultSrc,
		}));
	};

	return (
		<>
			<LinkPanel
				linkData={getLinkUrlData(src)}
				onChange={handleChange}
				isUrlLinkOnly={true}
			/>
			{src !== defaultSrc &&
				<Button
					type="button"
					onClick={handleResetClick}
				>
					<Translate value="messages.reset_to_default" />
				</Button>
			}
		</>
	);
};

export default IframePanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/IframePanel/index.tsx